import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ReportAndActivitySkeletonLoader = () => {
  return (
    <div className="w-full md:w-[30%] mt-10 md:mt-0">
      {/* Skeleton for Reports Section */}
      <div className="border border-gray-300 rounded-md p-5 bg-gray-100">
        <div className="border-b border-gray-300">
          <Skeleton width={100} height={20} />
        </div>
        <div className="py-5 border-b border-gray-300 space-y-5">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="flex items-center justify-between border-b border-gray-300 py-5"
            >
              <Skeleton circle={true} height={20} width={20} />
              <Skeleton width="60%" height={15} />
              <Skeleton width={40} height={15} />
            </div>
          ))}
        </div>
        <div className="text-center py-5">
          <Skeleton width={150} height={30} />
        </div>
      </div>

      {/* Skeleton for Assessment Activity Section */}
      <div className="mt-10 md:mt-6">
        <Skeleton width={200} height={20} />
        <div className="mt-6 space-y-6">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="relative flex gap-x-4">
              <div className="relative flex h-6 w-6 items-center justify-center">
                <Skeleton circle={true} height={10} width={10} />
              </div>
              <Skeleton width="80%" height={15} />
              <Skeleton width={60} height={15} />
            </div>
          ))}
        </div>
        <div className="border border-gray-300 rounded-md mt-10 p-4">
          <Skeleton width="100%" height={40} />
          <div className="self-end mt-4">
            <Skeleton width={100} height={30} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportAndActivitySkeletonLoader;
